export default __webpack_public_path__ + "static/media/image13.30426be1.svg";